var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_vm._v("\n  Multiple quotes notification for\n  "),_c('job-object',{attrs:{"job-number":_vm.activity.job_id}}),_vm._v("\n\n  emailed to CCT\n\n  "),_c('message-object',{attrs:{"tooltip":_vm.messageContent()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }